define('rebrush/components/category/layered/slider',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'cartware/components/Config',
    'cartware/dom/event/trigger'
], function(
    $,
    _,
    Component,
    BEM,
    Config,
    triggerEvent
) {
    function LayerSlider(block) {
        this.block = BEM.block(block);
        this.handles = this.block.getElements('price-slider-handle');
        this.bar = this.block.getElements('price-slider');
        this.span = this.block.getElements('price-slider-span');

        this.requestVar = this.block.find('.request-var').val();
        this.priceMin = parseInt(this.block.find('.price-min').val());
        this.priceMax = parseInt(this.block.find('.price-max').val());
        this.priceValueMin = parseInt(this.block.find('.price-value-min').val());
        this.priceValueMax = parseInt(this.block.find('.price-value-max').val());

        this.formInput = this.block.getElements('form-input');

        this.initializeSlider();
        this._bindEvents();
    }

    LayerSlider.prototype = {
        activeHandle: null,
        activeHandleIdx: null,

        _bindEvents: function() {
            this.bar.on('mousemove', _.bind(function(event) {
                var posHandleL = this.handles.get(0).cumulativeOffset().left;
                var posHandleR = this.handles.get(1).cumulativeOffset().left;
                var posPointer = Event.pointerX(event);
                if (posPointer > posHandleR || posPointer > ((posHandleR + posHandleL) / 2)) {
                    this.activeHandle = this.handles.get(1);
                    this.activeHandleIdx = 1;
                } else {
                    this.activeHandle = this.handles.get(0);
                    this.activeHandleIdx = 0;
                }
                // BubblePriceSlider.updateStyles();
            }, this));
        },

        initializeSlider: function() {
            var self = this,
                formatCurrency = window.formatCurrency,
                priceFormat = Config.get('currency.format');

            priceFormat.requiredPrecision = 0;

            new Control.Slider(this.handles.toArray(), this.bar.get(0), {
                range: $R(this.priceMin, this.priceMax),
                sliderValue: [this.priceValueMin, this.priceValueMax],
                restricted: true,
                spans: this.span.toArray(),
                onSlide: function(v) {
                    if (!isNaN(v[0])) {
                        self.bar.find('.price-range span.price')[0].update(formatCurrency(v[0], priceFormat, false));
                    }
                    if (!isNaN(v[1])) {
                        self.bar.find('.price-range span.price')[1].update(formatCurrency(v[1], priceFormat, false));
                    }
                },
                onChange: function(v) {
                    var min = v[0].toFixed(),
                        max = v[1].toFixed();

                    if (min === 0 || isNaN(min) || min <= this.range.start) {
                        min = '';
                    }
                    if (max >= this.range.end || isNaN(max)) {
                        max = '';
                    }

                    self.setRange(min, max);
                }
            });
        },

        setRange: function(min, max) {
            this.formInput.val([min, max].join('-'));
            triggerEvent(this.formInput.get(0), 'change');
        }
    };

    return Component.create({
        $init: function() {
            this.block = BEM.block('layer-slider');
            this.block.each(function() {
                $(this).data('component/layer-slide', new LayerSlider(this));
            });
        }
    });
});
